export enum MarketingPromo {
  TapeMeasureWithPurchase = 'TAPE_MEASURE_WITH_PURCHASE',
  None = '',
}
